import { MetadataTableName, UiMessageKey } from '@bechtel/sr-types';
import { get } from 'lodash';
import { DeleteCommodityResult } from './types';

export const getDeleteInput = (name: MetadataTableName, id: string) => {
  switch (name) {
    case MetadataTableName.EQUIPMENT:
      return { deleteEquipmentInput: { id } };
    case MetadataTableName.EQUIPMENT_CODE:
      return { deleteEquipmentCodeInput: { id } };
    case MetadataTableName.CABLE:
      return { deleteCableInput: { id } };
    case MetadataTableName.RACEWAY:
      return { deleteRacewayInput: { id } };
    case MetadataTableName.JUMPER:
      return { deleteJumperInput: { id } };
    case MetadataTableName.CABLE_CODE:
      return { deleteCableCodeInput: { id } };
    case MetadataTableName.RACEWAY_CODE:
      return { deleteRacewayCodeInput: { id } };
    case MetadataTableName.COLOR_CODE:
      return { deleteColorCodeInput: { id } };
    case MetadataTableName.REEL:
      return { deleteReelInput: { id } };
    case MetadataTableName.FIRE_AREA:
      return { deleteFireAreaInput: { id } };
    case MetadataTableName.PACKAGE:
      return { deletePackageInput: { id } };
    default:
      return null;
  }
};

const getUIMessageKeys = (errors?: UiMessageKey[], infos?: UiMessageKey[]) => {
  if (errors && infos) return [...errors, ...infos];
  else if (errors && !infos) return errors;
  else if (!errors && infos) return infos;
  else return [];
};

export const getDeleteErrors = (name: MetadataTableName, data: DeleteCommodityResult): UiMessageKey[] => {
  switch (name) {
    case MetadataTableName.EQUIPMENT:
      return getUIMessageKeys(get(data, 'deleteEquipment.errors'), get(data, 'deleteEquipment.infos'));
    case MetadataTableName.EQUIPMENT_CODE:
      return getUIMessageKeys(get(data, 'deleteEquipmentCode.errors'));
    case MetadataTableName.CABLE:
      return getUIMessageKeys(get(data, 'deleteCable.errors'), get(data, 'deleteCable.infos'));
    case MetadataTableName.RACEWAY:
      return getUIMessageKeys(get(data, 'deleteRaceway.errors'), get(data, 'deleteRaceway.infos'));
    case MetadataTableName.JUMPER:
      return getUIMessageKeys(get(data, 'deleteJumper.errors'), get(data, 'deleteJumper.infos'));
    case MetadataTableName.CABLE_CODE:
      return getUIMessageKeys(get(data, 'deleteCableCode.errors'));
    case MetadataTableName.RACEWAY_CODE:
      return getUIMessageKeys(get(data, 'deleteRacewayCode.errors'));
    case MetadataTableName.COLOR_CODE:
      return getUIMessageKeys(get(data, 'deleteColorCode.errors'));
    case MetadataTableName.REEL:
      return getUIMessageKeys(get(data, 'deleteReel.errors'));
    case MetadataTableName.FIRE_AREA:
      return getUIMessageKeys(get(data, 'deleteFireArea.errors'));
    case MetadataTableName.PACKAGE:
      return getUIMessageKeys(get(data, 'deletePackage.errors'));
    default:
      return [];
  }
};

export const getEntityText = (name: MetadataTableName) => {
  switch (name) {
    case MetadataTableName.EQUIPMENT:
      return 'Equipment';
    case MetadataTableName.EQUIPMENT_CODE:
      return 'Equipment Code';
    case MetadataTableName.CABLE:
      return 'Cable';
    case MetadataTableName.RACEWAY:
      return 'Raceway';
    case MetadataTableName.JUMPER:
      return 'Jumper';
    case MetadataTableName.CABLE_CODE:
      return 'Cable Code';
    case MetadataTableName.RACEWAY_CODE:
      return 'Raceway Code';
    case MetadataTableName.COLOR_CODE:
      return 'Color Code';
    case MetadataTableName.REEL:
      return 'Reel';
    case MetadataTableName.FIRE_AREA:
      return 'Fire Area';
    case MetadataTableName.PACKAGE:
      return 'Package';
    default:
      return '';
  }
};

export const getCommodityIdentifier = (name: MetadataTableName) => {
  switch (name) {
    case MetadataTableName.EQUIPMENT:
      return 'Equipment';
    case MetadataTableName.EQUIPMENT_CODE:
      return 'EquipmentCode';
    case MetadataTableName.CABLE:
      return 'Cable';
    case MetadataTableName.RACEWAY:
      return 'Raceway';
    case MetadataTableName.JUMPER:
      return 'Jumper';
    case MetadataTableName.CABLE_CODE:
      return 'CableCode';
    case MetadataTableName.RACEWAY_CODE:
      return 'RacewayCode';
    case MetadataTableName.COLOR_CODE:
      return 'ColorCode';
    case MetadataTableName.REEL:
      return 'Reel';
    case MetadataTableName.FIRE_AREA:
      return 'FireArea';
    case MetadataTableName.PACKAGE:
      return 'Package';
    default:
      return '';
  }
};
